import { createContext } from 'react';

const MemoContext = createContext();

export default MemoContext;
